"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateIsEligibleForFlexPay = void 0;
const usStatesAndTerritories_1 = require("../../locations/usStatesAndTerritories");
/**
 * These states are not eligible for Flex Pay
 */
const StatesWhereFlexPayIneligible = [
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Connecticut,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Maine,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Massachusetts,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Oklahoma,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Unknown,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Other,
];
/**
 * Uses our list of states where Flex Pay is ineligible to determine if a state is eligible for Flex Pay
 * @param state
 * @returns
 */
const StateIsEligibleForFlexPay = (state) => !StatesWhereFlexPayIneligible.includes(state);
exports.StateIsEligibleForFlexPay = StateIsEligibleForFlexPay;
//# sourceMappingURL=StateIsEligibleForFlexPay.js.map